export default __webpack_public_path__ + "static/media/Digital Keys.1ec3b459.svg";